<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent :max-width="mainDialogWidth">
      <v-card>
        <v-card-title class="subtitle-1 indigo darken-1 white--text">会員情報表示</v-card-title>
        <br/>
        <v-row class="ml-3 mr-3">
          <v-col cols="12">
            <v-text-field label="代表者氏名" :value="dispName" readonly></v-text-field>
            <v-text-field label="代表者氏名(フリガナ)" :value="dispKanaName" readonly></v-text-field>
            <v-text-field label="担当者氏名" :value="dispManagerName" readonly></v-text-field>
            <v-text-field label="担当者氏名(フリガナ)" :value="dispKanaManagerName" readonly></v-text-field>
            <v-text-field label="会社" :value="dispCompanyNm" readonly></v-text-field>
            <v-text-field label="会社(フリガナ)" :value="dispCompanyKanaNm" readonly></v-text-field>
            <v-text-field label="郵便番号" :value="dispZipCd" readonly></v-text-field>
            <v-text-field label="住所" :value="dispZip" readonly></v-text-field>
            <v-text-field label="電話番号" :value="telNo" readonly></v-text-field>
            <v-text-field label="メールアドレス" :value="mailAddress" readonly></v-text-field>
            <v-text-field label="入会日" :value="joinDate" readonly></v-text-field>
            <v-text-field label="退会日" :value="unsubscribeDate" readonly></v-text-field>
            <v-text-field label="最終更新日時" :value="updateDatetime" readonly></v-text-field>
            <v-text-field label="削除日時" :value="deleteDatetime" readonly></v-text-field>

          </v-col>
        </v-row>
        <br/>    
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded class="indigo darken-1 white--text" dark @click="yes()"> OK </v-btn>
        </v-card-actions>
        <br/>
      </v-card>
    </v-dialog>
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
  </v-row>
</template>

<script>
import Constants from "../common/constants";
export default {
  props: ["id", "isOpen", "doYes"],
  data() {
    return {
      dialog: false,
      dispCustomerId:"",
      dispName: "",
      dispKanaName: "",
      dispManagerName:"",
      dispKanaManagerName:"",
      dispCompanyNm: "",
      dispCompanyKanaNm: "",
      dispZipCd: "",
      dispZip: "",
      telNo: "",
      mailAddress: "",
      joinDate: "",
      unsubscribeDate: "",
      updateDatetime: "",
      deleteDatetime: "",
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
    };
  },
   watch: {
    id: function(val) {
      if (!this.dialog) {
        this.dispCustomerId = val;
        console.log(this.dispCustomerId);
      }
    },
    isOpen: function (val) {
      this.dialog = val;
      if (this.dialog) {
        console.log(this.dispCustomerId);
        this.initialize();
      }
    },
    
  },
  computed: {
    mainDialogWidth() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' || bp == 'sm') {
        return "100%";
      } else {
        return "40%";
      }
    },
  },
  created() {
   
  },
  methods: {
    yes() {
      this.doYes();
      this.dialog = false;
    },

    /*
    * 初期表示
    */
    initialize: function () {
      // 会員情報検索・表示
      this.getAccountInfo();
    },

    /*
    * 会員情報検索
    */
    getAccountInfo: async function () {
      let responseData = null;
      let apiErrorInfo = null;
      try{
         let apiurl = Constants.getUrlApiMTM100G01(this.dispCustomerId);
         let accessToken = this.$store.getters["authcUser/getAccessToken"];
          // API呼出
         let response = await this.$axios.get(apiurl,  
             {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            }); 
         responseData = response.data;
         console.log(response);
         this.setDispData(responseData);
      }catch(error) {
        apiErrorInfo = error.response.data;
      } 

      // 完了メッセージ表示
      this.showDialogMsgAfterAPICall(this.dlgMsg, apiErrorInfo, responseData);
    },

    /*
    * 会員情報表示
    */
    setDispData(responseData) {
      if (responseData.data == null) {
        return;
      }
      let customer = responseData.data;

      this.dispName = customer.name;
      this.dispKanaName = customer.nameKana;

      this.dispManagerName = customer.managerName;
      this.dispKanaManagerName = customer.managerNameKana;

      this.dispCompanyNm = customer.companyName;
      this.dispCompanyKanaNm = customer.companyNameKana;
      this.dispZipCd = customer.zipCode;
      this.dispZip = customer.address;
      this.telNo = customer.telNo;
      this.mailAddress = customer.mailAddress;
      this.joinDate = customer.joinDate;
      this.unsubscribeDate = customer.unsubscribeDate;
      this.updateDatetime = customer.updateDatetime;
      this.deleteDatetime = customer.deleteDatetime;

    },

    /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(dialog, apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        dialog.msg = this.$i18n.t('msg.err.cm100', ['会員情報']);
        dialog.isOpen = true;
        this.desserts.push({});
        return hasError;
      }
      // API処理異常
      if (responseData.statusCd === 500) {
          dialog.msg = responseData.message ;
          dialog.isOpen = true;
          this.desserts.push({});
         return hasError;
      }
    },
  },
};
</script>